/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const styleguideSectionStyle = {
  header: (theme: Theme) => ({
    top: 0,
    left: 0,
    backgroundColor: theme.palette.common.white,
    zIndex: 1200,
    width: "100%",
    paddingTop: "1rem",
    [theme.breakpoints.up("md")]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  }),
  title: {
    margin: 0,
    width: "100%",
    padding: "0.25rem 0 1rem",
  },
};
